import { removeClass, matchSwatchesWidth, available, notAvailable } from './functions'

HTMLDocument.prototype.ready = function () {
  // Document load/ready promise, calls 'ready' method when completed
  return new Promise(function (resolve, reject) {
    if (document.readyState === 'complete') {
      resolve(document)
    } else {
      document.addEventListener('DOMContentLoaded', function () {
        resolve(document)
      })
    }
  })
}

document.ready().then(function () {
  // On a Yarn product page
  if (document.getElementById('shopify-section-product-template-yarns')) {
    // Client request
    const forcePerRowMobile = 7

    const gallery = document.querySelector('.YarnGallery')
    const images = document.querySelectorAll('.YarnGallery__ImageWrapper')
    const swatches = document.querySelectorAll('form .colors-wrapper .swatch-circle')
    const noStockButton = document.getElementById('BIS_trigger')
    const popoverSelect = document.querySelector('.Product__OffScreen .OptionSelector')
    let submitButton = document.querySelector('.ProductForm__AddToCart')
    const colorsWrapper = document.querySelector('.colors-wrapper')
    const variantsWrapper = document.querySelector('.ProductForm__Variants')
    const masterSelect = document.querySelector('form .ProductForm__Option.no-js select')
    let gridItems

    // 'phone' CSS breakpoint
    if (window.viewportWidth <= 640) {
      // set height equal to width
      gallery.style.height = `${gallery.getBoundingClientRect().width}px`
    } else {
      // Reset any inline styles
      gallery.style.height = ''
    }

    window.addEventListener('resize.optimized', function (event) {
      // 'phone' CSS breakpoint
      if (window.viewportWidth <= 640) {
        // set height equal to width
        gallery.style.height = `${gallery.getBoundingClientRect().width}px`
      } else {
        // Reset any inline styles
        gallery.style.height = ''
      }
    })

    if (colorsWrapper) {
      // convert nodelist to array
      gridItems = Array.from(colorsWrapper.children)
    }

    if (colorsWrapper && submitButton) {
      // Larger screens
      if (window.viewportWidth >= window.mainBreakpoint) {
        matchSwatchesWidth(colorsWrapper, gridItems, [submitButton, noStockButton])
        gallery.style.width = ''
      } else {
        matchSwatchesWidth(
          colorsWrapper,
          gridItems,
          [submitButton, noStockButton, gallery],
          forcePerRowMobile
        )
      }

      window.addEventListener('resize.optimized', function () {
        if (window.viewportWidth >= window.mainBreakpoint) {
          matchSwatchesWidth(colorsWrapper, gridItems, [submitButton, noStockButton])
          gallery.style.width = ''
        } else {
          matchSwatchesWidth(
            colorsWrapper,
            gridItems,
            [submitButton, noStockButton, gallery],
            forcePerRowMobile
          )
        }
      })
    }

    // ======================================= //
    // ============= ON PAGE LOAD ============ //
    // ======================================= //
    for (const image of images) {
      // We only want items with images, so we loop over the image wrappers
      const id = image.dataset.variant
      const swatch = document.querySelector(`form .swatch-circle[data-variant="${id}"]`)
      // The option in the hidden select menu
      const option = masterSelect.querySelector(`option[value="${id}"]`)
      const popoverOption = popoverSelect.querySelector(`button[data-value="${swatch.dataset.variantName}"]`)
      //   let variantInfo = window.yarnVariants[id];

      const variantInfo = window.yarnVariants.find((el) => Number(el.id) === Number(id))

      if (option.hasAttribute('selected') && variantInfo.available === 'false') {
        console.log('selected and not available')
        notAvailable(submitButton, noStockButton)
      }

      // Add the elements to their existing nested variant object
      variantInfo.image = image
      variantInfo.swatch = swatch
      variantInfo.option = option

      variantInfo.color = swatch.dataset.variantColor
      variantInfo.name = swatch.dataset.variantName

      swatch.addEventListener('click', function (event) {
        // Triggers the 'variant:changed' event
        popoverOption.click()
      })
    }

    document.addEventListener('variant:changed', function (event) {
      // Gives you access to the variant details from theme
      const { variant } = event.detail
      const { id } = variant

      console.log('variant is...')
      console.log(variant)
      console.log('id is....')
      console.log(id)

      // Gives additional details, custom
      //   let variantInfo = window.yarnVariants[id];
      const variantInfo = window.yarnVariants.find((el) => Number(el.id) === Number(id))

      console.log('variant info is...')
      console.log(variantInfo)

      submitButton = document.querySelector('button.ProductForm__AddToCart')

      removeClass(images, 'active')
      removeClass(swatches, 'active')

      if (variantInfo.image) {
        variantInfo.image.classList.add('active')
      }

      if (variantInfo.swatch) {
        variantInfo.swatch.classList.add('active')
      }

      if (variant.available === true) {
        console.log('is available')
        available(submitButton, noStockButton)
      } else {
        console.log('is not available')
        notAvailable(submitButton, noStockButton)
      }

      if (window.viewportWidth >= window.mainBreakpoint) {
        matchSwatchesWidth(colorsWrapper, gridItems, [submitButton, noStockButton])
      } else {
        matchSwatchesWidth(colorsWrapper, gridItems, [submitButton, noStockButton], forcePerRowMobile)
      }

      console.log(variant)
      console.log(variantInfo)
    })

    console.log(window.yarnVariants)





  }
  const variantSwatches = document.querySelectorAll('.swatch-circle');
  variantSwatches.forEach(element => {

    if (element.getAttribute("data-discontinued") === "true" && element.getAttribute("data-available") === "false") {
      element.classList.add('display-none');

    }
  });





})

